import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { Form, Input } from "antd";
import LoadableButton from "../../../components/buttons/LoadableButton";
import { setloggedIn } from "../../../store/slices/userSlice";
import { ChangePasswordApi, LogoutApi } from "../../../api/request/users";
import { removeCookies } from "../../../services/Cookies";
import { IpProvider } from "../../../services/IpProvider";

export default function ChangePasswordMobile() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { userDetails } = useSelector((state) => state.user);
  const [ipAddress, setIpAddress] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const getIpAddress = async () => {
    try {
      const { data } = await IpProvider();
      setIpAddress(data?.ip);
    } catch (error) {}
  };

  useEffect(() => {
    getIpAddress();
  }, []);

  const logoutHandler = async () => {
    try {
      setIsLoading(true);
      const { data } = await LogoutApi({ ipAddress });
      if (data?.success) {
      }
      localStorage.clear();
      dispatch(setloggedIn(false));
      removeCookies("token");
      navigate("/");
      setIsLoading(false);
    } catch (err) {
      dispatch(setloggedIn(false));
      removeCookies("token");
      navigate("/");
    }
  };

  const handleSubmit = async (values) => {
    const { oldPassword, newPassword, confirmPassword } = values;
    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match.");
      return;
    }
    const params = {
      id: userDetails?.id,
      oldPassword,
      password: newPassword,
      confirmPassword,
    };
    try {
      setIsLoading(true);
      const { data } = await ChangePasswordApi(params);
      if (data?.success) {
        toast.success(data?.message);
        form.resetFields();
        logoutHandler();
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message);
      setIsLoading(false);
    }
  };

  return (
    <div className="mobile-dashboard min-h-screen">
      <div className="grid xl:grid-cols-2 xl:gap-5">
        <p className="text-sm text-gray-600">
          Change Your Password to Keep Your Account Safe and Secure
        </p>
        <Form
          autoComplete="off"
          onFinish={handleSubmit}
          form={form}
          className="mt-5"
        >
          <div className="">
            <div className="grid sm:grid-cols-2 gap-4 mb-8">
              <div>
                <Form.Item
                  name="oldPassword"
                  rules={[
                    {
                      required: true,
                      message: "Please input your current password!",
                    },
                  ]}
                >
                  <Input.Password
                    size="large"
                    placeholder="Current Password"
                    className="rounded-xl border-[#E2E8F0]"
                  />
                </Form.Item>
              </div>
              <div>
                <Form.Item
                  name="newPassword"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Please input your new password!",
                    },
                    {
                      validator: (_, value) => {
                        if (!value) return Promise.resolve();
                        if (value.length < 8) {
                          return Promise.reject(
                            new Error(
                              "Password must be at least 8 characters long."
                            )
                          );
                        }
                        if (!/[a-z]/.test(value)) {
                          return Promise.reject(
                            new Error(
                              "Password must contain at least one lowercase letter."
                            )
                          );
                        }
                        if (!/[A-Z]/.test(value)) {
                          return Promise.reject(
                            new Error(
                              "Password must contain at least one uppercase letter."
                            )
                          );
                        }
                        if (!/\d/.test(value)) {
                          return Promise.reject(
                            new Error(
                              "Password must contain at least one number."
                            )
                          );
                        }
                        if (
                          !/[!@#$%^&*(),.?":{}|<>_\-\\[\];'/`~]/.test(value)
                        ) {
                          return Promise.reject(
                            new Error(
                              "Password must contain at least one special character."
                            )
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input.Password
                    size="large"
                    placeholder="New Password"
                    className="rounded-xl border-[#E2E8F0]"
                  />
                </Form.Item>
              </div>

              <div>
                <Form.Item
                  dependencies={["newPassword"]}
                  hasFeedback
                  name="confirmPassword"
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your new password!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("newPassword") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "The new password that you entered do not match!"
                          )
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    size="large"
                    placeholder="Confirm Password"
                    className="rounded-xl border-[#E2E8F0]"
                  />
                </Form.Item>
              </div>
            </div>

            <div className="mt-6 flex gap-4">
              <LoadableButton
                type="submit"
                className="bg-primary-mobile text-sm text-white font-medium px-6 py-4 w-full rounded-lg themeHover duration-500"
                lable="Change Password"
                loadingLable="Updating..."
                isLoading={isLoading}
                disabled={isLoading}
              />
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
}
